import { colors } from '../../colors';
var imageGallery = {
  primaryColor: colors.white,
  bgColor: colors.slateGrey,
  tileBgColor: colors.white,
  iconBgColor: colors.slateGrey
};
export default imageGallery;